export const API_ENDPOINTS = {
    BEDFINDER: {
        GETREQUESTFROMOTHERS: "bedfinder/namespace/bedfinder/requests/received",
        GETAGENCY: "bedfinder/agencies",
        GETUSER: "bedfinder/user",
        GETUSERS: "bedfinder/users",
        CREATEUSER: "bedfinder/users",
        GETMYAGENCY: "bedfinder/agencies",
        SENDRESPONSE: "bedfinder/namespace/bedfinder/requests/{requestId}/responses",
        GETMYREQUEST: "bedfinder/namespace/bedfinder/requests/sent",
        CLOSEREQUEST: "bedfinder/namespace/bedfinder/requests/{requestId}",
        GETREQUESTDETAILS: "bedfinder/namespace/bedfinder/requests/{requestId}",
        GETREQUESTRESPONSES: "bedfinder/namespace/bedfinder/requests/{requestId}/responses",
        CLOSENEED: "bedfinder/namespace/bedfinder/needs/{needId}",
        GETNEEDDETAILS: "bedfinder/namespace/bedfinder/needs/{needId}",
        GETGROUPS: "bedfinder/groups",
        CREATENEED: "bedfinder/namespace/bedfinder/needs",
        CREATEREQUEST: "bedfinder/namespace/bedfinder/needs/{needId}/requests",
        GETMEMBERLIST: "bedfinder/collaboratives/{collaborativeId}",
        GETCOLLABORATIVELIST: "bedfinder/collaboratives",
        UPDATEUSERSETTINGS: "bedfinder/agencies/{agencyId}"
    },
    SAFENIIGHT: {
        GETRECENTDONATIONS: "bedfinder/namespace/safenight/donations",
        GETRECENTNEEDS: "bedfinder/namespace/safenight/needs",
        GETDONERS: "bedfinder/namespace/safenight/donors",
        UPDATEREQUEST: "bedfinder/namespace/safenight/requests",
        SENDDONATIONRECEIPT: "bedfinder/namespace/safenight/donations/{donationId}/sendreceipt",
        GETDONORDONATIONS: "bedfinder/namespace/safenight/donors/{donorId}/donations",
    }
};